<template>
  <v-card class="mb-4"
          v-if="team.sharing_enabled && presentation.can_be_shared">
    <v-card-title>
      Sharing
    </v-card-title>
    <v-simple-table>
      <tbody>
      <tr>
        <td>
          Sharing Email Template
        </td>
        <td>
          <div v-if="shareTemplate">
            <router-link :to="{name: 'share_template.show', params: {id: shareTemplate.id}}">
              {{ shareTemplate.name }}
            </router-link>
          </div>
          <div v-if="!shareTemplate">
            None
          </div>
        </td>
      </tr>
      <tr>
        <td>
          Sharing Theme
        </td>
        <td>
          <div v-if="shareTheme">
            <router-link :to="{name: 'share_theme.edit', params: {themeID: shareTheme.id}}">
              {{ shareTheme.name }}
            </router-link>
          </div>
          <div v-if="!shareTheme">
            Default
          </div>
        </td>
      </tr>
      <tr>
        <td>
          Subdomain
        </td>
        <td>
          <div v-if="presentation.subdomain">
            {{ presentation.subdomain }}.mobilelocker.com
          </div>
          <div v-else>
            Not configured
          </div>
        </td>
      </tr>
      <tr>
        <td>
          3rd Party Analytics
        </td>
        <td>
          <div v-if="presentation.facebook_pixel">
            Facebook: {{ presentation.facebook_pixel }}
          </div>
          <div v-if="presentation.google_analytics_id">
            Google Analytics: {{ presentation.google_analytics_id }}
          </div>
          <div v-if="presentation.hubspot_pixel">
            Hubspot: {{ presentation.hubspot_pixel }}
          </div>
          <div v-if="presentation.linkedin_pixel">
            LinkedIn: {{ presentation.linkedin_pixel }}
          </div>
          <div v-if="!presentation.facebook_pixel && !presentation.google_analytics_id && !presentation.hubspot_pixel && !presentation.linkedin_pixel">
            Not configured
          </div>
        </td>
      </tr>
      <tr>
        <td>
          Slack notifications
        </td>
        <td>
          <div v-if="presentation.slack_url">
            A incoming webhook is configured
          </div>
          <div v-else-if="team.slack_url">
            Using the team incoming webhook
          </div>
          <div v-else>
            Not configured
          </div>
        </td>
      </tr>
      </tbody>
    </v-simple-table>
  </v-card>
</template>
<script>
import {mapGetters} from 'vuex';
import shareThemeService from "../../../../../ml/services/shareThemeService";
import {find} from "lodash";

export default {
  props: {
    presentation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      shareTheme: null,
    }
  },
  computed: {
    ...mapGetters([
      'shareTemplates',
      'team',
      'user',
    ]),
    shareTemplate() {
      if (this.presentation.share_template_id) {
        return find(this.shareTemplates, t => t.id === this.presentation.share_template_id);
      }
      return null;
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      if (this.presentation.share_theme_id) {
        shareThemeService.getTheme(this.presentation.share_theme_id)
          .then(data => {
            this.shareTheme = data;
          })
      }
    }
  }
}
</script>
